export default __webpack_public_path__ + "static/media/PM.49693a5f.svg";